export const IS_CATEGORIES_FETCHING = 'IS_CATEGORIES_FETCHING';
export const CATEGORIES_FETCHING_ERROR = 'CATEGORIES_FETCHING_ERROR'
export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';



// WEBPACK FOOTER //
// ./src/redux_related/categories/actions.js